import React from "react";
import { useNavigate } from "react-router-dom";

interface Props {
  bookId: string;
}

const DownloadButtons: React.FC<Props> = ({ bookId }) => {
  const navigate = useNavigate();

  const downloadPDF = async (transcreated: boolean) => {
    const url = `${process.env.REACT_APP_API_URL}/download-pdf/${bookId}?transcreated=${transcreated}`;
    const response = await fetch(url);
    const blob = await response.blob();
    const downloadUrl = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = downloadUrl;
    a.download = transcreated ? "transcreated_book.pdf" : "translated_book.pdf";
    a.click();
    a.remove();
  };

  const handleNewEdit = () => {
    navigate("/edit", { state: bookId });
  };

  return (
    <div style={{ marginTop: "2rem" }}>
      <button onClick={() => downloadPDF(false)}>
        Download Translated PDF
      </button>
      <button onClick={() => downloadPDF(true)} style={{ marginLeft: "1rem" }}>
        Download Transcreated PDF
      </button>
      <button onClick={handleNewEdit} style={{ marginLeft: "1rem" }}>
        Start a New Edit
      </button>
    </div>
  );
};

export default DownloadButtons;
